import { render, staticRenderFns } from "./DetailNote.vue?vue&type=template&id=1f034742&"
import script from "./DetailNote.vue?vue&type=script&lang=js&"
export * from "./DetailNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports